import React, {Component} from "react"
import PropTypes from "prop-types"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import {Wallet} from "@irati/types"

import {Label} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {walletTracking} from "@irati-tracking/wallet"
import {FormattedMessage, FormattedCurrency, InjectIntl, injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

import {Content, Title, Balances, Balance, TTCurrency, StyledCaption, Trigger, ActiveCard} from "./styled"

import RewardsTriggerModal from "../RewardsModal/RewardsTriggerModal"

interface Props extends WithAuth, InjectIntl {
  wallet: Wallet,
  active: boolean
}

class RewardWallet extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  handleCardClick = () => {
    walletTracking.clickRewardPointsCard(this.props.auth.userTenant.uuid)
  }

  render() {
    const {wallet, formatMessage, active} = this.props
    const {amount, currency} = wallet
    const {apps} = this.context
    const idNamespace = id("balances", this.props)

    return (
      <ActiveCard id={idNamespace} marginTop={5} active={active} onClick={this.handleCardClick}>
        <Content>
          <Trigger>
            <RewardsTriggerModal />
          </Trigger>
          <Title marginBottom={2}>
            <FormattedMessage id="wallet.reward.admin.card.topup.rewardPoints" />
          </Title>
          <Balances>
            <Balance id={id("available-balance", idNamespace)}>
              <Label>
                <FormattedMessage id="wallet.walletBalanceCard.available.header" />
              </Label>
              <TTCurrency>{currency && <FormattedCurrency value={amount} currency={currency} />}</TTCurrency>
            </Balance>
          </Balances>
          <div>
            <StyledCaption>
              <FormattedMessage id="wallet.availableBalance.info.rewardText" />
            </StyledCaption>
            <ButtonRouterLink
              id={id("browse-perks-button", idNamespace)}
              primary
              full
              stopPropagation
              onClick={() => walletTracking.clickBrowseRewards(formatMessage({id: "wallet.reward.tracking.source.title"}))}
              to="/"
              app={apps.FLEXIREWARDS}>
              <FormattedMessage id="wallet.rewardPoints.availableBalance.info.button" />
            </ButtonRouterLink>
          </div>
        </Content>
      </ActiveCard>
    )
  }
}

export default withAuth(injectIntl(RewardWallet))
